import React, { lazy } from "react";

const LazyJeAccrual = lazy(() => import("./JeAccrual"));

const JeAccrual = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyJeAccrual {...props} />;

export default JeAccrual;
